const initialState = {
  fetching: false,
  fetched: false,
  timeSheetData: [],
  error: null,
  organization: null
};

export const timeSheetTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_TIME_SHEET_TREE_VIEWER": {
      return initialState;
    }
    case "OPEN_TIME_SHEET_TREE_VIEWER": {
      return { ...state, error: null, ...action.viewer };
    }
    case "INIT_TIME_SHEET_TREE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        timeSheetData: [],
        error: null
      };
    }
    case "SET_TIME_SHEET_TREE_ORGANIZATION": {
      return { ...state, organization: action.organization };
    }
    case "SET_TIME_SHEET_TREE_MODEL": {
      return { ...state, model: action.model };
    }
    case "SET_TIME_SHEET_TREE": {
      let data = action.payload;
      return { ...state, ...data };
    }
    case "FETCH_TIME_SHEET_TREE_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_TIME_SHEET_TREE_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        timeSheetData: data,
        organization: action.payload.organization
      };
    }
    case "FETCH_TIME_SHEET_TREE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        timeSheetData: [],
        error
      };
    }
    default:
      return state;
  }
};
const initialTimeSheetSearchWordState = {
  searchWord: ""
};
export const timeSheetSearchWordReducer = (
  state = initialTimeSheetSearchWordState,
  action
) => {
  switch (action.type) {
    case "SET_TIME_SHEET_SEARCH_WORD": {
      return {
        ...state,
        searchWord: action.searchWord
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/time-sheet-tree.js